import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    isDashboardInit: boolean;
  };
}

export const setIsDashboardInitDispatch = (
  state: ScheduleState,
  action: Action
) => {
  const { isDashboardInit } = action.payload;
  state.isDashboardInit = isDashboardInit;
};
